import { useMutation } from 'react-query';
import { Data } from './useCharitableGivingQuery';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';

export const SAVE_CHARITABLE_GIVING_WORKFLOW_MK = 'saveCharitableGivingWorkflow--mutation-key';

interface FetcherParams {
  clientId: number;
  model: Data;
}

const saveWorkflow = ({ clientId, model }: FetcherParams) => {
  return authFetch('/Consumer/CharitableGivingWorkflowUpdate', {
    method: 'POST',
    ...httpBodyOptions({ clientId, model }),
  });
};

export const useCharitableGivingMutation = () => {
  return useMutation(saveWorkflow, {
    mutationKey: SAVE_CHARITABLE_GIVING_WORKFLOW_MK,
  });
};
